import i18nFactory from '@yandex-int/i18n';

import { DateRangePreset } from '../../typings/common';
import { GdCampaignBudgetShowMode } from '../../typings/graphql-grid';

import * as keyset from './TextStoreHelpers.i18n';

const helperI18N = i18nFactory(keyset);

export function getTitleForDateRangePreset(preset: DateRangePreset): string {
    const dateRangePresetsDictionary = {
        today: helperI18N('today'),
        yesterday: helperI18N('yesterday'),
        currentWeek: helperI18N('currentWeek'),
        previousWeek: helperI18N('previousWeek'),
        last7Days: helperI18N('last7Days'),
        currentMonth: helperI18N('currentMonth'),
        previousMonth: helperI18N('previousMonth'),
        last30Days: helperI18N('last30Days'),
        last90Days: helperI18N('last90Days'),
        last365Days: helperI18N('last365Days'),
        allTime: helperI18N('allTime')
    };

    if (!dateRangePresetsDictionary[preset]) {
        throw new Error(`Для значения ${preset} не определено название`);
    }

    return dateRangePresetsDictionary[preset];
}

export function getTitleForDayBudgetMode(
    mode: GdCampaignBudgetShowMode
): string {
    const dictionary = {
        [GdCampaignBudgetShowMode.DEFAULT]: helperI18N('defaultBudgetMode'),
        [GdCampaignBudgetShowMode.STRETCHED]: helperI18N('stretchedBudgetMode')
    };

    if (!dictionary[mode]) {
        throw new Error(
            `Для для режима дневного бюджета ${mode} не определено название`
        );
    }

    return dictionary[mode];
}

export function getDateName(name: string): string {
    return {
        today: helperI18N('today'),
        yesterday: helperI18N('yesterday')
    }[name];
}

export function getReportsSuccessTexts(action: string): string {
    return {
        addReport: helperI18N('report-enqueued')
    }[action];
}
